module.exports = __webpack_public_path__ + "img/ic_done.2c84a207.svg";